import { useMemo, useCallback } from 'react';
import {
  clearAllStorage,
  getFromStorage,
  removeFromStorage,
  setInStorage,
} from '../scripts/common/StorageHelper';

const useSessionStorage = () => {
  //Check if hook is invoked from the client and has sessionStorage
  const hasSessionStorage = useMemo(() => {
    try {
      const key = `__storage__test`;
      window.sessionStorage.setItem(key, null);
      window.sessionStorage.removeItem(key);
      return true;
    } catch (e) {
      return false;
    }
  }, []);

  /**
   * Get item in storage if hook is invoked from client.
   * @param {*} key Item Key
   * @returns The value saved against the key. Returns JSON is object otherwise string.
   */
  const getStorageItem = useCallback((key) => {
    return getFromStorage(key);
  }, []);

  /**
   * Saves item in storage if hook is invoked from client. Value is saved as string.
   * @param {*} key Item Key
   * @param {*} value Can be an object or string. It is converted to string before save.
   * @returns Returns true if item was saved else false
   */
  const setStorageItem = useCallback((key, value) => {
    return setInStorage(key, value);
  }, []);

  /**
   * Removes the item from storage.
   * @param {*} key
   */
  const removeStorageItem = useCallback((key) => {
    return removeFromStorage(key);
  }, []);

  /**
   * Clears session storage
   */
  const clearStorage = useCallback(() => {
    return clearAllStorage();
  }, []);

  return {
    getStorageItem,
    setStorageItem,
    removeStorageItem,
    clearStorage,
    hasSessionStorage,
  };
};

export default useSessionStorage;
